import { Tooltip } from "@mui/material";
import React from "react";

const ToolTipComponent = ({
  text,
  placement = "top",
  children,
  height,
  offset,
  style,
  arrowStyle,
  textOnly,
  open = null,
  disableInteractive = false,
  disable = false,
  darkMode = false,
}) => {
  return (
    <Tooltip
      // open={open}
      placement={placement}
      title={text}
      arrow
      disableInteractive={disableInteractive}
      disableHoverListener={disable}
      PopperProps={{
        sx: {
          inset: textOnly ? "auto auto 17px auto !important" : "",
        },
        modifiers: [
          {
            name: "offset",
            options: {
              offset: offset === "right" ? [90, -5] : offset === "slightly-right" ? [20, -5] : [0, -5],
            },
          },
        ],
      }}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: darkMode ? "#535353" : "white",
            color: darkMode ? "#FFFFFF" : "black",
            // fontWeight:500,
            fontSize: "10px",
            letterSpacing: "1px",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px;",
            // height: height || "50px",
            display: "block",
            alignItems: "center",
            marginBottom: textOnly ? "0px !important" : "",
            ...style,
          },
        },
        arrow: {
          sx: {
            color: darkMode ? "#535353" : "white",
            ...arrowStyle,
          },
        },
      }}
    >
      {/* <button onClick={handleMenuOpen} type="button" className="text-2541558A hover:text-254155">
  <i className="bi bi-plus-lg"></i>
</button> */}
      {children}
    </Tooltip>
  );
};

export default ToolTipComponent;
